import Actions              from 'Redux/Actions';
import { AppUserRepository } from 'Domain/Repositories';
import { ofType }           from 'redux-observable';
import { from }             from 'rxjs';
import { mergeMap }         from 'rxjs/operators';
import { TEpic }            from 'Redux/Config';

export const findAppUserEventsEpic: TEpic = (action$) => {
  return action$.pipe(
    ofType(Actions.findAppUserEventsRequest.type),
    mergeMap(action => from(
      AppUserRepository.findEvents(action.payload)
        .then(({ eventIds }: { eventIds: string[] }) => Actions.findAppUserEventsSuccess({ organisationId: action.payload.organisationId, eventIds }))
        .catch((error: Error) => Actions.findAppUserEventsFailure({ error })),
    )),
  );
};
